import { useRef } from "react";
import { usePosthogIdentityReady } from "~/context/posthog";
import { trackParticipation } from "~/utils/analytics";
import { ParticipationAnalytics } from "./analytics";

export function useAppHandoff(eventId: string | undefined, viewerId: string | undefined) {
  const ready = usePosthogIdentityReady();
  const journal = useRef<{ scope: string; analytics: ParticipationAnalytics } | null>(null);
  return () => {
    if (!ready || !eventId) return;
    const scope = `${eventId}:${viewerId ?? "anonymous"}`;
    try {
      if (journal.current?.scope !== scope) {
        journal.current = { scope, analytics: new ParticipationAnalytics(scope, {
          journey_kind: "rsvp_handoff", event_id: eventId,
          is_test_run: window.ENV?.SENTRY_ENVIRONMENT === "development",
        }, trackParticipation) };
      }
      journal.current.analytics.view("select", "entry");
      journal.current.analytics.complete("app_handoff");
    } catch { /* The app handoff must work even when analytics is unavailable. */ }
  };
}
